import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import ReplayIcon from '@mui/icons-material/Replay'
import dayjs from 'dayjs'
import { CustomColumnGridConfig } from '../types'
import { renderAlertWithMutedIndication } from '@/utils/mutedAlertRenderer'
import { severityHebrewFromValue } from '@/utils/severity'
import ResendAlertButton from '@/components/notification-send/ResendAlertButton'
import MeterLink from '@/components/Table/MeterLink'

const notificationsColumns: CustomColumnGridConfig[] = [
  {
    field: 'meterNumber',
    headerName: 'מספר מד',
    flex: 1,
    filter: { type: 'search' },
    filterable: true,
    renderCell: (params: any) => {
      const meter = params.row.meterNumber
      if (meter == null) return '-'
      return (
        <MeterLink
          meter={meter}
          sx={{
            color: theme =>
              theme.palette.mode === 'dark' ? '#90caf9' : '#1976d2',
          }}
        />
      )
    },
  },
  {
    field: 'consumerName',
    headerName: 'שם צרכן',
    flex: 1.2,
    filter: { type: 'search' },
    filterable: true,
    renderCell: (params: any) => params.value || params.row.consumerName || params.row.name || '-',
  },
  {
    field: 'address',
    headerName: 'כתובת',
    flex: 1.2,
    filter: { type: 'search' },
    filterable: true,
    renderCell: (params: any) => params.value || params.row.address || '-',
  },
  {
    field: 'waterCard',
    headerName: 'כרטיס מים',
    flex: 1,
    filter: { type: 'search' },
    filterable: true,
    renderCell: (params: any) => params.value || params.row.waterCard || '-',
  },
  {
    field: 'severity',
    headerName: 'חומרה',
    flex: 1.1,
    filter: { type: 'options' },
    filterable: true,
    renderCell: (params: any) => {
      // Engine writes a raw integer severity on each alert instance
      // (Low=-10, Medium=0, High=10). Map it through the shared util so this
      // grid agrees with the ניהול התראות cards and with the engine.
      const severityLabel = severityHebrewFromValue(params.row.severity)

      const dotColor = severityLabel === 'גבוהה' || severityLabel === 'גבוהה מאוד'
        ? '#FF4D4F'
        : severityLabel === 'בינונית'
          ? '#FFA940'
          : '#52C41A'

      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center', width: '100%' }}>
          <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: dotColor }} />
          <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
            חומרה {severityLabel}
          </Typography>
        </Box>
      )
    },
  },
  {
    field: 'alertTypeName',
    headerName: 'התראה',
    flex: 1.3,
    filter: { type: 'options' },
    filterable: true,
    renderCell: (params: any) => renderAlertWithMutedIndication(params.row.alertTypeName ?? '-', params.row),
  },
  {
    field: 'openedAt',
    headerName: 'ת.פתיחה',
    flex: 1.1,
    filter: { type: 'none' },
    filterable: false,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },
  {
    field: 'closedAt',
    headerName: 'ת.סגירה',
    flex: 1.1,
    filter: { type: 'none' },
    filterable: false,
    renderCell: (params: any) => {
      return params.value ? dayjs(params.value).format('DD/MM/YYYY') : '-'
    },
  },
  {
    field: 'resend',
    headerName: '',
    flex: 0.5,
    sortable: false,
    filterable: false,
    filter: { type: 'none' },
    renderCell: (params: any) => {
      const accountIdRaw = localStorage.getItem('accountId')
      const accountId = accountIdRaw ? Number(accountIdRaw) : NaN
      if (Number.isNaN(accountId)) {
        return (
          <Tooltip title="שליחה חוזרת">
            <span>
              <IconButton size="small" disabled>
                <ReplayIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        )
      }
      return <ResendAlertButton accountId={accountId} alertId={params.row.id} />
    },
  },
]

export default notificationsColumns
